module.exports = __webpack_public_path__ + "static/img/1.8168c01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/1.png
// module id = TwG1
// module chunks = 0